export class ErrorMessageService {
  getUserMessage({ errorCode = "", message = "" }) {
    if (errorCode) {
      var langKey = "ApiMessage_" + errorCode;
      const translated = window.$t(langKey);

      if (translated && translated !== langKey)
        return translated;      
    }

    if (message)
      return message;    

    // Genel fallback
    return window.$t("Unexpected_Error");
  }
}
